export default "__VITE_ASSET__BRVmyh7c__"